import React from "react";
import { FORMAT_NUMBER } from "../../../common/utils";
const CompanyChartAbout = props => {
  const { chartData } = props;
  return (
    <div className="event-page-company-chart-section">
      <div className="event-page-company-chart-section-title">About</div>
      <div className="event-page-company-chart-section-row">
        {chartData?.overview?.sector ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Sector
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {chartData?.overview?.sector}
            </div>
          </div>
        ) : null}

        {chartData?.overview?.industry ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Industry
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {chartData?.overview?.industry}
            </div>
          </div>
        ) : null}
        {chartData?.overview?.ceo ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              {chartData?.overview?.ceo?.Title}
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {chartData?.overview?.ceo?.Name}
            </div>
          </div>
        ) : null}

        {chartData?.overview?.WebURL ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Website
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              <a
                href={chartData?.overview?.WebURL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-link text-primary"
              >
                {chartData?.overview?.WebURL}
              </a>
            </div>
          </div>
        ) : null}
        {chartData?.overview?.address ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Headquarters
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {chartData?.overview?.address}
            </div>
          </div>
        ) : null}

        {chartData?.overview?.figi ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              FIGI
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {chartData?.overview?.figi}
            </div>
          </div>
        ) : null}

        {chartData?.overview?.fullTimeEmployees ? (
          <div className="event-page-company-chart-section-row-item">
            <div className="event-page-company-chart-section-row-item-label">
              Employees
            </div>
            <div className="event-page-company-chart-section-row-item-text">
              {FORMAT_NUMBER(chartData?.overview?.fullTimeEmployees)}
            </div>
          </div>
        ) : null}

        {chartData?.overview?.description ? (
          <div className="event-page-company-chart-section-row-item event-page-company-chart-section-row-item-full">
            <div className="event-page-company-chart-section-row-item-text">
              {chartData?.overview?.description}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CompanyChartAbout;
